// Ported from apps/webapp/src/components/gantt-chart/components/empty-chart-row.tsx:99-145
// (`Container`, `AddStripButton`, `Content`). The old grid placed a whole row of hit cells and
// showed the one under the cursor via `gridColumnStart`; here there is exactly one button, moved
// to the hovered/focused day with a `left` written from `scale.xOf` (see empty-row-add.tsx), so no
// grid is needed to reproduce the same 4.8rem x 4rem cell geometry.
.hitLayer {
  position: absolute;
  inset: 0;
}

// 4.8rem x 4rem: `AddStripButton`'s exact size. No token exists for either number; port literally.
.addButton {
  all: unset;
  position: absolute;
  top: 0;
  display: flex;
  width: 4.8rem;
  height: 4rem;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  // Same layer as the bar this affordance stands in for (row-list.tsx never renders both in the
  // same track), not the resize-strip/off-screen-chip layer above it.
  z-index: 4;

  // Hidden until hovered or focused, rather than absent from the DOM: an element removed from
  // layout (`display: none`) is also removed from the tab order, so a keyboard user tabbing
  // through the row would have nothing to land focus ON in the first place. Opacity plus
  // `pointer-events` keeps it reachable by Tab while inert to the pointer until shown — the same
  // reveal-on-focus shape a skip link uses.
  opacity: 0;
  pointer-events: none;

  &[data-visible='true'] {
    opacity: 1;
    pointer-events: auto;
  }
}

// 3.2rem square, `--color-primary-crayola`, white icon: `Content`'s exact values.
.content {
  display: flex;
  width: 3.2rem;
  height: 3.2rem;
  padding: 0.4rem 0.8rem;
  justify-content: center;
  align-items: center;
  border-radius: var(--border-radius-small);
  background: var(--color-primary-crayola);
  box-sizing: border-box;

  & > svg {
    min-width: 2.4rem;
    min-height: 2.4rem;
  }
}
